import React from 'react'
import { useArticuloBimLink } from 'context/ArticuloBimLinkContext'

const Descripcion = () => {
  const { descripcion, handleDescripcion } = useArticuloBimLink()

  const handleChange = (e) => {
    const value = e.target.value
    handleDescripcion(value)
  }

  return (
    <div className="descripcion-scroll-container">
      <div className="new-bimlink-input">
        <label htmlFor="descripcion" className="new-bimlink-label">Descripción</label>
        <textarea
          id="descripcion"
          name="descripcion"
          rows={5}
          className="new-bimlink-textarea"
          value={descripcion}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

export default Descripcion